export const API_URL_SHARE_QUOTE_OR_RESULTS = "/Documents";
export const API_URL_POST_QUOTE = "/Quote/Save";
export const API_URL_POST_SEND_COMMUNICATION = "/Quote/D2C/SendCommunication";
export const API_URL_CREATE_ONLINE_QUOTE = "Quote/D2C/Start";
export const API_URL_POST_ONLINE_QUOTE = "/Quote/D2C/Save";
export const API_URL_POST_SDN = "/SDN";
export const API_URL_RETRIEVE_QUOTE = "/Quote";
export const API_URL_RETRIEVE_D2C_QUOTE_BY_REF = "Quote/D2C/Retrieve";
export const API_URL_ANNUAL_REQUOTE = "/AnnualRequote";
export const API_URL_CONFIRM_ELIGIBILITY = "Quote/D2C/ConfirmEligibility";
export const API_URL_RETRIEVE_D2C_QUOTE_BY_QUOTEACCESS =
  "Quote/D2C/QuoteAccess";
export const API_URL_UPDATE_SELECTED_QUOTE = "Quote/D2C/UpdateSelectedQuote";
export const API_URL_SYNC_QUOTE_REQUEST = "Quote/D2C/SyncQuoteRequest";
export const API_URL_LOGIN = "/Security/Login";
export const API_URL_REFRESH = "/Security/Refresh";
export const API_URL_PROPERTY_LOOKUP = "/PropertyLookup";
export const API_URL_GET_OCCUPATIONS = "/catalogue/occupations";
export const API_URL_GET_INDUSTRIES = "/catalogue/industries";
export const API_URL_GET_PRODUCTS = "/catalogue/products";
export const API_URL_GET_SYSTEM = "/catalogue/system";
export const API_URL_GET_PRODUCT_PRICING = "/Catalogue/Product";
export const API_URL_GET_QUOTE_DOCUMENTS_LIST = "/Documents";
export const API_URL_GET_STATIC_DOCUMENTS_LIST = "/Documents/Product";
export const API_URL_UPDATE_QUOTE = "UpdateQuote";
export const API_URL_SAVE_RESULT_STAGE = "SaveResultStage";
export const API_URL_APPLY = "Apply";
export const API_URL_EMAIL = "Email";
export const API_START_D2C_SESSION = "Session/D2C/Start";
export const API_REFRESH_D2C_SESSION = "Session/D2C/Refresh";
export const API_URL_CREATE_LEAD_QUOTE_MULTIPLE_PROPERTY =
  "Quote/D2C/CreateLeadAndLeadQuoteForMultiplePropertyLead";
export const API_URL_GET_APP_CONFIGURATION = "/AppConfiguration";
export const API_URL_GET_APP_BUSINESS_TIME =
  "https://customerhubapi.paymentshield.co.uk/api/BusinessTime/business-times";

//LexisNexus
export const API_URL_ADDRESSY =
  "https://api.addressy.com/Capture/Interactive/{0}/v1.10/json3.ws?Key=KU12-JD51-XZ77-ZW73&Text={1}&IsMiddleware=&Container={2}&Id={3}&Origin=GB&Countries=GB&Limit=&Language=en-gb&Bias=true&Filters=Language:eng";

export const API_GET_EMBED_LOGO = "/Image/HtmlSource";

export const API_ERROR_STATUS = [401, 403];
